module.exports = __webpack_public_path__ + "img/vehicle_cover.6794fe09.png";